import { Box, Button, Stack, Typography } from "@mui/material";
import { FeaturePermission } from "@/__generated__/featurePermissions";
import { hasRole, useUser } from "@/auth/useUser";
import { UserPlusIcon } from "@/components/common/icons";
import { VIOLET } from "@/config/mui/colorPalette";
import NextLink from "@/config/mui/nextLink";
import { useMedspaId } from "@/hooks/common/useMedspaId";
import { useIsGfeReviewer } from "@/hooks/user/useIsGfeReviewer";
import { MEDICAL_DIRECTOR } from "@/types";
import InfoCard from "../infoCard/infoCard";

export default function ReferralCard() {
  const medspa = useMedspaId();
  const { user, newPermissionsEnabledForUser, hasFeaturePermission } =
    useUser();

  const isMd = newPermissionsEnabledForUser
    ? hasFeaturePermission(FeaturePermission.IS_MEDICAL_DIRECTOR)
    : hasRole(user, [MEDICAL_DIRECTOR]);

  const isGfeReviewer = useIsGfeReviewer();

  // referral should be 1000 for MD and GFE Reviewer, 500 for Provider
  // note: the GFE Reviewer check is redundant at this point,
  // leaving it to avoid confusing roles and permissions team when switching to a new GFE Reviewer role
  const referralAmount = isMd || isGfeReviewer ? 1000 : 500;

  return (
    <InfoCard
      sx={{
        my: 0,
        ".MuiCardContent-root": { p: 1.5 },
      }}
    >
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Box
            sx={{
              backgroundColor: VIOLET[20],
              borderRadius: 100,
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <UserPlusIcon size={20} color={VIOLET[90]} set="duotone" />
          </Box>
          <Typography variant="labelSmall" color="text.primary">
            Refer & Earn
          </Typography>
        </Stack>
        <Typography
          variant="paragraphSmall"
          color="text.secondary"
          sx={{ mb: 1 }}
        >
          Refer a provider to Moxie and earn{" "}
          <Typography
            variant="subtitleSmall"
            color="text.primary"
            component="span"
          >
            ${referralAmount}
          </Typography>{" "}
          at launch.
        </Typography>
        <Button
          component={NextLink}
          href={`/${medspa}/referral`}
          variant="contained"
          size="small"
          sx={{
            backgroundColor: VIOLET[40],
            color: VIOLET[90],
            "&:hover": {
              backgroundColor: VIOLET[60],
            },
          }}
        >
          Learn more
        </Button>
      </Stack>
    </InfoCard>
  );
}
